import React from 'react'
import Icon from '../../../../ui/Icon/Icon'
import styles from './OrderPaymentInfo.module.scss'

const PAYMENT_TYPE_CONFIG = {
  cash: {
    title: 'При отриманні',
    icon: 'money-bill-wave',
  },
  card: {
    title: 'Онлайн',
    icon: 'credit-card',
  },
}

function OrderPaymentInfo({ type }) {
  const config = PAYMENT_TYPE_CONFIG[type]

  if (!config) return null

  return (
    <div className={styles.root}>
      <div className={styles.iconWrap}>
        <Icon name={config.icon} className={styles.icon} />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{config.title}</div>
      </div>
    </div>
  )
}

export { PAYMENT_TYPE_CONFIG }
export default OrderPaymentInfo
